//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
let d=[[[0,"AngleTolerance",1,0],[0,"CheckSurfaces",1,0],[0,"DistanceTolerance",1,0],[1,"ExtendLength",0,"Expression",0],[1,"GuideLineAngle1",0,"Expression",0],[1,"GuideLineAngle2",0,"Expression",0],[1,"SegmentEdges",0,"ScCollector",0],[1,"SheetEdges",0,"Section",0]],[[[],"ResetAllSegments",{},0,0],[[],"UpdateSheetEdges",{},0,0],[["segmentType"],"SetSelectedSegmentType",{},1,0],[[],"MergeSegment",{},0,0],[[],"SplitSegment",{},0,0],[[],"RestoreSegments",{},0,0],[["assocEdge","guideLinePnt","guideLineVector","guideLineLength"],"CreateGuideLine",{R_:{guideLine:"Curve"}},4,0],[[],"UpdateAllGuideLinesLength",{},0,0],[["guideLine","guideLineVector","guideLineLength"],"ChangeGuideLineDirectionAndLength",{},3,0],[["lastSelectedLoopIndex"],"SetLastSelectedLoopIndex",{},1,0],[["reverseExtendDirection"],"SetReverseExtendDirection",{},1,0]],[]];
SPLM.Tooling.GuidedExtensionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.GuidedExtensionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.GuidedExtensionBuilder.SegmentType = Object.freeze({
    "Normal" : "Normal", "Transition" : "Transition", "Bypass" : "Bypass"});

export default SPLM;